import React from 'react';

import { flagStyles } from '../settings';

const SvgLI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3048px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLI;
